module.exports = __webpack_public_path__ + "static/img/1400x770-2.e21b99e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1400x770-2.jpg
// module id = 9h56
// module chunks = 2 6